import { ListItemButton, ListItemText } from '@mui/material';
import { Link, useRouteMatch } from 'react-router-dom';
import { PermissionBoundary } from '../../../../../../core/permissions/permission-boundary.component';
import { NavigationItem } from '../../navigation-bar.component';
import { useNavMenuMobileItemStyles } from './nav-menu-mobile-item.styles';

export function NavMenuMobileItem({ item, onClick }: { item: NavigationItem; onClick(...args: any): void }) {
  const navProps = item.url ? { component: Link, to: item.url } : {};
  const match = useRouteMatch({ path: item.url, exact: true });
  const classes = useNavMenuMobileItemStyles({ isSelected: match?.isExact });
  return (
    <PermissionBoundary permissions={item.permissions} availableUiFeatures={item.availableUiFeatures}>
      <ListItemButton className={classes.menuItemsMobile__button} {...navProps} onClick={onClick}>
        <ListItemText>{item.text}</ListItemText>
      </ListItemButton>
    </PermissionBoundary>
  );
}
